"use client";

import { useState } from "react";
import { Box, styled } from "@mui/material";
import { Button, SplitButton } from "@/ui";
import AddToFloatDialog from "../modals/AddToFloatDialog";

const ActionsBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(1),
}));

export default function CandidateActions({ candidate, onFloat, onSubmit, size = "small" }) {
  const [addToFloatOpen, setAddToFloatOpen] = useState(false);
  const who = candidate?.name?.trim().split(/\s+/)[0] || "candidate";
  const splitSize = size === "small" ? "sm" : "md";

  return (
    <ActionsBox>
      <SplitButton
        label={`Float ${who}`}
        variant="primary"
        size={splitSize}
        mainOpensMenu
        items={[
          { label: "Create new float", onClick: onFloat },
          { label: "Add to existing float", onClick: () => setAddToFloatOpen(true) },
        ]}
      />
      <Button variant="primary" size={splitSize} onClick={onSubmit}>
        Submit {who}
      </Button>
      <AddToFloatDialog
        open={addToFloatOpen}
        onClose={() => setAddToFloatOpen(false)}
        candidate={candidate}
      />
    </ActionsBox>
  );
}
